module.exports = __webpack_public_path__ + "img/banner_02.7bab016c.jpg";